module.exports = __webpack_public_path__ + "img/icon-npay-s.dd1e2194.svg";